import React from 'react';
import { useDropzone } from 'react-dropzone';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { varAlpha } from 'src/theme/styles';

import { Iconify } from '../iconify';

// ----------------------------------------------------------------------

export function UploadBox({ placeholder, error, disabled, sx, setSelectedImage, onUploadingChange, imageSec = null, ...other }) {
  const [image, setImage] = React.useState(imageSec);
  const [isUploading, setIsUploading] = React.useState(false);

  // Sync local image state when imageSec prop changes (e.g. opening edit modal)
  React.useEffect(() => {
    setImage(imageSec);
  }, [imageSec]);

  const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
    disabled: disabled || isUploading,
    ...other,
    onDrop: (files) => {
      setImage(URL.createObjectURL(files[0]));
      setIsUploading(true);
      if (onUploadingChange) onUploadingChange(true);

      const formdata = new FormData();
      formdata.append("file", files[0], files[0].name);
      formdata.append("nomae", "teste");

      const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
      };

      fetch("https://cursiverso.azurewebsites.net/image/add-image", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          setSelectedImage(result.files[0].url);
        })
        .catch((errorUpload) => {
          console.error(errorUpload);
          setSelectedImage(null);
        })
        .finally(() => {
          setIsUploading(false);
          if (onUploadingChange) onUploadingChange(false);
        });
    },
  });

  const hasError = isDragReject || error;

  return (
    <Box
      {...getRootProps()}
      sx={{
        width: 64,
        height: 64,
        flexShrink: 0,
        display: 'flex',
        borderRadius: 1,
        cursor: isUploading ? 'wait' : 'pointer',
        alignItems: 'center',
        color: 'white',
        justifyContent: 'center',
        bgcolor: "#91365A",
        border: (theme) => `dashed 1px ${varAlpha(theme.vars.palette.grey['500Channel'], 0.16)}`,
        ...(isDragActive && { opacity: 0.72 }),
        ...((disabled || isUploading) && { opacity: 0.48, pointerEvents: 'none' }),
        ...(hasError && {
          color: 'error.main',
          borderColor: 'error.main',
          bgcolor: (theme) => varAlpha(theme.vars.palette.error.mainChannel, 0.08),
        }),
        '&:hover': { opacity: isUploading ? 0.48 : 0.72 },
        ...sx,
      }}
    >
      <input {...getInputProps()} />

      {isUploading ? (
        <CircularProgress size={28} sx={{ color: 'white' }} />
      ) : image === null ? (
        <>
          {placeholder || <Iconify icon="eva:cloud-upload-fill" width={28} />}
        </>
      ) : (
        <img src={image} alt="upload" style={{ width: '100%', height: '100%', objectFit: 'contain', maxHeight: 200 }} />
      )}
    </Box>
  );
}
